import React from 'react';
import {Input} from "@material-tailwind/react";
import {Search} from "@mui/icons-material";
import {useTranslation} from "react-i18next";
import {reemplaceValue} from "../../utils/textOptions";
import {CustomTypography} from "./CustomTypography";
interface CustomInputSearchProps {
    type?: string;
    value?: string;
    placeholder?: string;
    label?: string;
    disabled?: boolean;
    className?: string;
    maxLength?: number;
    onChangeText?: (text: string) => void;
    error?: string;
    onClick?: any;
    testId?: string;
}

function CustomInputSearch({ type, maxLength, disabled, placeholder, label, className, error, onClick, testId, ...props }: CustomInputSearchProps) {
    const { t } = useTranslation("global") as { t: (key: string) => string }
    const [focus, setFocus] = React.useState(false);
    const handleInputChange = (event: any) => {
        return reemplaceValue(type, event.target.value, maxLength);
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        const { key } = event;
        const upperCaseKey = key.toUpperCase();

        if (upperCaseKey === 'ENTER') {
            event.preventDefault();
            onClick()
        }
    };

    const event = () => {
        if (!disabled) {
            onClick()
        }
    }

    return (
        <div className={`${className} w-full flex flex-col ${error ? '' : 'mb-4'}`}>
            <label className={`${disabled ? 'text-colorDisabled' : 'text-labelColor'} labelCustom normal-case text-[10px] absolute bg-white mt-[-9px] ml-[18px] labelCustom px-1 rounded-[5px]`}>{label}</label>
            <Input
                data-testid={testId}
                crossOrigin=''
                onFocus={() => {setFocus(true)}}
                onBlur={() => {setFocus(false)}}
                disabled={disabled}
                placeholder={placeholder ? placeholder : t('search')}
                value={props.value}
                onKeyDown={handleKeyDown}
                className={`styleInput custom-input-search text-input disabled:text-colorDisabled  pt-3 min-h-[40px] max-h-[40px] !border ${disabled ? '!border-colorDisabled' : '!border-inputBorder'} bg-white shadow-lg
                shadow-gray-900/5 ring-1 ring-transparent ${disabled ? 'placeholder:text-colorDisabled' : 'placeholder:text-gray-500'} focus:!border-primary
                focus:!border-t-primary focus:ring-white disabled:bg-white`}
                labelProps={{
                    className: "hidden",
                }}
                containerProps={{ className: "min-w-[52px]" }}
                onChange={(e) => {
                    if (props.onChangeText) props.onChangeText(handleInputChange(e))
                }}
                icon={
                    <Search className={`w-[20px] min-w-[20px] max-w-[30px] ${focus && !disabled ? 'text-primary' : disabled ? 'text-colorDisabled' : 'text-header'}`}
                                               onClick={() => {event()}}
                    />
                }
            />
            {error && <CustomTypography variant="small" style={{color: 'red'}} className="font-normal ml-2 mt-3" text={error}/>}
        </div>
    );
}

export default CustomInputSearch;
